/** Two letters for the circle beside a name: "Asha Mehta" is "AM". */
export function initials(name: string): string {
  const letters = name
    .split(/\s+/)
    .filter((word) => word !== "")
    .map((word) => word.charAt(0).toUpperCase());
  return (
    letters.length > 1
      ? `${letters[0] ?? ""}${letters[letters.length - 1] ?? ""}`
      : (letters[0] ?? "?")
  ).slice(0, 2);
}

const AVATAR_TINTS = [
  "bg-tint-blue text-tint-blue-foreground",
  "bg-tint-green text-tint-green-foreground",
  "bg-tint-purple text-tint-purple-foreground",
  "bg-tint-orange text-tint-orange-foreground",
  "bg-tint-pink text-tint-pink-foreground",
  "bg-tint-brown text-tint-brown-foreground",
] as const;

/**
 * The circle's colour, fixed by the record's own key rather than its name
 * (#637): two customers both called Riya Shah get the same letters but, most
 * of the time, not the same colour.
 */
export function avatarTint(key: string): string {
  let hash = 0;
  for (const char of key) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return AVATAR_TINTS[hash % AVATAR_TINTS.length] ?? AVATAR_TINTS[0];
}
